<template>
  <div v-if="summaryData">
    <a-row type="flex" style="align-items: center;">
      <a-col style="text-align: center;">
       <a-row type="flex" style="align-items: center;">
        <a-col flex="74px" align="left">
          <a-avatar :size="74" icon="user"></a-avatar>
        </a-col>
        <a-col align="left" style="margin:0 20px;">
          <div>
            <div style="font-weight: 700;font-size:1.1rem;color:#333;margin-bottom: 6px;">
              <span v-if="summaryData.titleDict">{{ summaryData.titleDict.enName }} </span>
              <span>{{ summaryData.fullName ? summaryData.fullName.replace(/,/g, ', ') : '' }}</span>
            </div>
            <div v-if="summaryData.globalCode && summaryData.globalCode !== '' ">
             <strong>Global No.:</strong><span> {{ summaryData.globalCode }}</span>
            </div>
            <!--customerCode  -->
            <!-- <div>
              <strong>Memebership:</strong>
            </div> -->
            <!--  <div style="margin-top: 2px;">
              <span style="margin-right: 20px;" v-if="summaryData.signetCustomerCode && summaryData.signetCustomerCode !== '' "><strong>Signet:</strong> {{ summaryData.signetCustomerCode }}</span>
              <span v-if="summaryData.superaCustomerCode && summaryData.superaCustomerCode !== '' "><strong>Supera:</strong> {{summaryData.superaCustomerCode}}</span>
            </div> -->
          </div>
        </a-col>
       </a-row>
      </a-col>
      <!-- right -->
    </a-row>
  </div>
</template>

<script>
import { Title } from '@/utils/helper/standard-code-utils'

export default {
  name: 'CdbCustomerSummary',
  components: {
  },
  props: {
    initData: {
      type: [Object],
      default: null
    },
    countryList: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      summaryData: null,
      // backgroundList: NationalBackground.dict,
    }
  },
  mounted () {
    this.loadData ()
  },
  methods: {
    async loadData () {
      this.summaryData = null
      const summaryData = this.copyDataByJSON(this.initData)
      if (summaryData) {
        // 客人Title
        let title = summaryData.title
        if (title && title !== '') {
          title = Title.getByCode(title)
          summaryData.titleDict = title
        }
      }
      this.summaryData = summaryData
    },
    getCountryById (countryId) {
      if (this.countryList && this.countryList.length > 0) {
        const fs = this.countryList.filter(c => {
          return c.id == countryId
        })
        if (fs && fs.length > 0) {
          return fs[0]
        }
      }
      return null
    },
    // 添加 /线
    getLanguageById (languageId) {
        const fs = this.languageList.filter(c => {
          return c.id == languageId
        })
        if (fs && fs.length > 0) {
          return fs[0]
        }
      return null
    },
  },
  watch: {
    initData (val) {
      this.summaryData = this.copyDataByJSON(val)
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
.ant-divider-horizontal {
  margin: 10px 0;
}
.summary-right {
  margin:5px  0 0 20px;
  font-size: 1rem;
}
.summary-right span {
  margin-right:30px;
  display: inline-block;
}
.summary-right span > h4{
  display: inline-block;
  margin-right: 8px;
}
.summary-right a {
  text-decoration:underline;
}
.men-no {
  margin: 0 !important;
}
</style>
